import React, { useState, useEffect, useRef } from 'react'
import Dashboard from 'src/views/dashboard/Dashboard'
import './idCard.css'
// import { useReactToPrint } from 'react-to-print';
import {
    CNav,
    CNavItem,
    CNavLink,
    CRow,
    CTabContent,
    CTabPane,
    CModal,
    CTabs,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CBadge,
    CDataTable,
    CButton,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CForm,
    CSelect,
    CFormGroup,
    CInputGroupAppend,
    CInputGroup,
    CLabel,
    CInputCheckbox,
    CSwitch,
    CFormText,
    CInput,
    CInputFile
} from '@coreui/react'
import { data } from 'jquery'

import { config } from 'src/utils/apiUrl'

import API from '../../utils/apiCalling';


const ModalDocuments = (props) => {
    const { isOpen_Doc, isViewModalOpen_Doc, selectedViewDocument, printButton,empCardData } = props
    console.log(selectedViewDocument, "jhbdfjhs")

    const [newConvertValue, setNewConvertValue] = useState([])
    const [isShowEducationDetails, setIsShowEducationDetails] = useState(false)
    const api = new API();
    useEffect(() => {
        // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>....document", selectedViewDocument)
        setNewConvertValue([])
        filterData()
    }, [selectedViewDocument])
    const filterData = () => {
        if (selectedViewDocument && !selectedViewDocument.data) {
            let newVal = Object.entries(selectedViewDocument)
            // console.log("****************", newVal)
            setNewConvertValue(newVal)
        }
    }


    const iframeRef = useRef(null);
    const handlePrint = () => {
        let cardContent = `
          <div>Name: ${'UserName'}</div>
          <div>ID: ${156789}</div>
          `;
        cardContent = document.getElementById("printId").innerHTML;
        const iframe = iframeRef.current;
        iframe.contentWindow.document.open();
        //iframe.contentWindow.document.write(cardContent);
        iframe.contentWindow.document.write(`<!DOCTYPE html><html lang="en"><head><meta charset=UTF-8><meta http-equiv=X-UA-Compatible content="IE=edge"><meta name=viewport content="width=device-width,initial-scale=1"><title>ID Card</title><link href=https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/css/bootstrap.min.css rel=stylesheet integrity=sha384-KK94CHFLLe+nY2dmCWGMq91rCGa5gtU4mk92HdvYe+M/SXH301p5ILy+dN9+nJOZ crossorigin=anonymous><script src=https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/js/bootstrap.bundle.min.js integrity=sha384-ENjdO4Dr2bkBIFxQpeoTz1HIcje39Wm4jDKdf19U8gI4ddQ3GYNS7NTKfAdVQSZe crossorigin=anonymous></script><style>body{font-family:sans-serif}*{margin:0;padding:0;box-sizing:border-box}.man_idcard{width:300px;min-height:520px;box-shadow:0 0 6px #00000029;border-radius:10px;padding:10px 20px;margin:20px 10px;text-align:center;background-image:url(./img/designbg.svg);background-repeat:no-repeat;background-size:cover;background-position:center left}.empprofile img{height:120px;width:105px;object-fit:cover;border-radius:10px;border:2px solid #1167ad}.contentTxt strong{color:#1167ad;font-weight:700;font-size:16px;display:block;margin-bottom:2px}.textInner span{display:block;font-size:12px;font-weight:400;color:#000;text-align:left;margin-bottom:5px}.textInner b{min-width:84px;display:inline-block;font-weight:600;color:#1167ad}.signature{text-align:right;padding-bottom:20px}.signature span{color:#2986cb;font-size:12px;font-weight:600}.idBacktxt p{color:#2986cb;font-size:11px;font-weight:600;margin-bottom:25px;margin-top:22px;text-align:left}.idBacktxt .address{display:flex;font-size:11px;;font-weight:600;color:#2986cb;margin-bottom:40px}.idBacktxt b{display:block;text-align:left;white-space:wrap;font-weight:600;color:#2986cb;font-weight:500}.footerTxt strong{font-size:12px;font-weight:600;color:#2986cb;display:block}.footerTxt{margin-top:0;margin-bottom:0}.footerTxt span{font-size:9px;font-weight:600;color:#2986cb;display:block}.idBacktxt .textInner span{font-size:11px;margin-bottom:11px;font-weight:500}.idBacktxt .textInner b{min-width:90px;display:inline-block;font-weight:700}.idBacktxt .textInner span.address b {min-width: 52px;}.textInner{padding-top:8px}.idBacktxt .textInner{padding-top:20px;padding-top: 40px;margin-top: 40px;margin-bottom: 20px;height: 290px;}@media print{*{-webkit-print-color-adjust:exact}.man_idcard{min-height:520px}}</style></head><body>${cardContent}</body></html>`);
        iframe.contentWindow.document.close();
        iframe.focus();
        setTimeout(() => {
            iframe.contentWindow.print(); // Trigger printing     
        }, 2000);

    };

    const genetateEmpCard=async()=>{
        // let result = await api.post(config.generateIdCardImg,selectedViewDocument.data[0])
        // if (result&&result.code==200){
            window.open('https://edunextg.glueple.in:3016/idcards/empIdCardFront.jpg', '_blank')
            window.open('https://edunextg.glueple.in:3016/idcards/empIdCardBack.jpg', '_blank')
        // }else{

        // }
        // return(<>
        // {console.log("ataaaaaaaaaa")}
        //     <a href='https://edunextg.glueple.in:3016/idcards/empIdCardFront.jpg' download='empIdCardFront.jpg'/>
        //     <a href='https://edunextg.glueple.in:3016/idcards/empIdCardBack.jpg' download='empIdCardBack.jpg'/>
        //     </>
        // )
    }
    return (
        <div className="">
            <CModal
                show={isOpen_Doc}
                onClose={() => isViewModalOpen_Doc()}
                size="lg"
            >
                <CModalHeader closeButton>
                    <CModalTitle>{selectedViewDocument && selectedViewDocument.tag_name}
                    </CModalTitle>
                    {printButton &&<><div style={{ position: 'absolute', right: '200px' }}>
                        <button onClick={genetateEmpCard} className='btn btn-primary' disabled={empCardData?false:true}>Download ID Card</button>
                    </div>
                     <div style={{ position: 'absolute', right: '50px' }}>
                        <button onClick={handlePrint} className='btn btn-info' style={{color:'white'}}>Print ID Card</button>
                    </div></>}
                    <iframe ref={iframeRef} style={{ display: 'none' }} />
                </CModalHeader>
                <CModalBody>

                    <CForm action="" encType="multipart/form-data" className="form-horizontal">
                        <CRow>
                            <CCol md="12">

                                {newConvertValue && newConvertValue.length > 0 && newConvertValue.map((details, index) => (
                                    <div className="card-header-form" style={{ fontSize: "15px", fontWeight: "bolder" }}>
                                        <CFormGroup row>
                                            <div className="col-md-6">
                                                <CCol sm="12" md="12">

                                                    <CLabel ><span className="text-capitalize">{details[0].replace(/[^a-zA-Z ]/g, " ")}</span></CLabel>
                                                </CCol>
                                            </div>
                                            <CCol sm="6" md="6">
                                                <CInput disabled value={details[1]} name="id" placeholder="" />
                                            </CCol>
                                        </CFormGroup>

                                    </div>
                                ))}

                                <>
                                    {selectedViewDocument && selectedViewDocument.tag_name == "Education Details" && selectedViewDocument.data.map((details, index) => (
                                        <div>
                                            <div className="card">
                                                <div className="card-header">
                                                    Details {index + 1}

                                                </div>
                                                <div className="card-header">

                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Educational Class</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_educational_class} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Roll No</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_roll_no} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Smp School</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_school} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Board</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_board} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Percentage</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_percentage} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Year</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.year} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Emp Educational Class</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.emp_educational_class} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>

                                <>
                                    {selectedViewDocument && selectedViewDocument.tag_name == "Document Details" && selectedViewDocument.data.map((details, index) => (
                                        <div>
                                            <div className="card">
                                                <div className="card-header" >
                                                    Details {index + 1}
                                                    {details.status == 1 &&
                                                        <i className="fa fa-check" aria-hidden="true"></i>
                                                    }
                                                </div>
                                                {/* class={details.status == 0 ? {color:"red"} : {color:""}} */}
                                                <div className="card-body" >
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel ><span className="text-capitalize">Document Name</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput disabled value={details.document_name} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                    <CFormGroup row>
                                                        <CCol xs="12" md="3">
                                                            <CLabel  ><span className="text-capitalize">Document Status</span></CLabel>
                                                        </CCol>
                                                        <CCol xs="12" md="9">
                                                            <CInput style={details.status == 0 ? { backgroundColor: "" } : { backgroundColor: "lightgreen" }} disabled value={details.status == 0 ? "Pending" : "Complete"} name="id" placeholder="" />
                                                        </CCol>
                                                    </CFormGroup>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>

                                <>
                                    {selectedViewDocument && selectedViewDocument.tag_name == "ID Card Details" && selectedViewDocument.data.map((details, index) => (
                                        <div id='printId' className="container-fluid">
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <div className="man_idcard" style={{backgroundImage:'url(images/designbg.svg)'}}>
                                                    <div className="bg-images">
                                                        <div className="d-flex justify-content-center">
                                                            <img src="images/enLogo.png" alt="" width={130} height={80} />
                                                        </div>
                                                        <figure className="empprofile my-2 p-2">
                                                            <img src={details.employee_passport_size_photo ? details.employee_passport_size_photo : "images/logo.png"} alt="" width={100} />
                                                        </figure>
                                                        <div className="contentTxt">
                                                            <strong className="Name_emp">{details?.employee_name}</strong>
                                                            <div className="textInner">
                                                            <span>
                                                                    <b> Emp. Code </b>: {details?.emp_id}
                                                                </span>
                                                                <span>
                                                                    <b>Designation </b>: {(details.role_short_name && details.role_short_name != 'undefined') ? details.role_short_name : details.designation ? details.designation : ''}
                                                                </span>
                                                                <span>
                                                                    <b>Department </b>: {details?.department}
                                                                </span>
                                                                <span>
                                                                    <b>D.O.J </b>: {details?.joining_date}
                                                                </span>
                                                                <span>
                                                                    <b>D.O.B </b>: {details?.dob}
                                                                </span>
                                                                <span>
                                                                    <b>Blood Group </b>: {details?.blood_group}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="signature">
                                                            <figure className="m-0">
                                                                <img src="images/newSingn.png" alt="" width={120} height={25} />
                                                            </figure>
                                                            <span>Issuing Authority</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="man_idcard" style={{backgroundImage:'url(images/designbg.svg)'}}>
                                                    <div className="idBacktxt">
                                                        <p>
                                                            In case lost, you are request to <br /> post it at the below given
                                                            address
                                                        </p>
                                                        <div className="textInner">
                                                        <span>
                                                                <b>ADHAR NO </b> : {details?.aadhar_no}
                                                            </span>
                                                            <span>
                                                                <b>Card No </b> : {details?.card_no}
                                                            </span>
                                                            <span>
                                                                <b>Contact No </b> : {details?.emp_mobile}
                                                            </span>
                                                            <span>
                                                                <b>Emergency Mob. </b> : {details?.emergency}
                                                            </span>
                                                            <span>
                                                                <b>Company Mob. </b> : 9088399919
                                                            </span>
                                                        
                                                        
                                                        <span className="address m-0">
                                                            Email_ID : <b className="ms-1 text-black"> {details.email} </b>
                                                        </span>
                                                        <span className="address">
                                                            <b className='mr-0'>Address :</b>
                                                            <b className="ms-1 text-black">
                                                                {details.address}
                                                            </b>
                                                        </span></div>
                                                        <div className="footerTxt">
                                                            <strong>EDUNEXTG INDIA LLP</strong>
                                                            <span>
                                                                AF-333, RABINDRAPALLY, TALBAGAN, P.O. PRAFULLA KANAN, KOLKATA-700101
                                                            </span>
                                                            <span>Website-www.edunextg.in email-info@edunxtg.in</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                                </div>
                                            {/* <div className="d-flex justify-content-center">

                                                <div className="man_idcard">
                                                    <div className="bg-images">
                                                        <img src="images/enLogo.png" alt="" width={150} height={80} />
                                                        <figure className="profile profileBackground my-2 p-2">
                                                            <img src={details.employee_passport_size_photo ? details.employee_passport_size_photo : "images/logo.png"} alt="" width={100} />
                                                        </figure>
                                                        <div className="contentTxt">
                                                            <strong className="Name_emp">{details?.employee_name}</strong>
                                                            <div className="textInner">
                                                                <span>
                                                                    <b> Emp. Code </b>: {details?.emp_id}
                                                                </span>
                                                                <span>
                                                                    <b>Department </b>: {details?.department}
                                                                </span>
                                                                <span>
                                                                    <b>D.O.J </b>: {details?.joining_date}
                                                                </span>
                                                                <span>
                                                                    <b>D.O.B </b>: {details?.dob}
                                                                </span>
                                                                <span>
                                                                    <b>Blood Group </b>: {details?.blood_group}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="signature">
                                                            <figure className="m-0">
                                                                <img src="images/signature.png" alt="" width={80} />
                                                            </figure>
                                                            <span>Issuing Authority</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="man_idcard">
                                                    <div className="idBacktxt">
                                                        <p>In Case lost, you are request to post it at the below given address</p>
                                                        <div className="textInner">
                                                            <span>
                                                                <b>ADHAR NO </b> : {details?.aadhar_no}
                                                            </span>
                                                            <span>
                                                                <b>Card No </b> : {details?.card_no}
                                                            </span>
                                                            <span>
                                                                <b>Contact No </b> : {details?.mobile}
                                                            </span>
                                                            <span>
                                                                <b>Emergency Cont No </b> : {details?.emergency}
                                                            </span>
                                                            <span>
                                                                <b>Company Cont No </b> : +91 9088399919
                                                            </span>
                                                            <span>
                                                                <b>Email_ID </b> : {details.email}
                                                            </span>
                                                        </div>
                                                        <span className="address">
                                                            ADDRESS :{" "}
                                                            <b className="ms-1">
                                                                {" "}
                                                                4D Hari Abasan Phase-II Hanapara, Kestopur Dist-North 24 Parganas West
                                                                Bengal, 700101
                                                            </b>
                                                        </span>
                                                        <div className="footerTxt">
                                                            <strong>EDUNEXTG INDIA LLP</strong>
                                                            <span>
                                                                AF-333, RABINDRAPALLY, TALBAGAN, P.O. PRAFULLA KANAN, KOLKATA-700101
                                                            </span>
                                                            <span>Website-www.edunextg.in</span>
                                                            <span>email-info@edunxtg.in</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>

                                    ))}
                                </>


                            </CCol>
                        </CRow>
                    </CForm>
                </CModalBody>
                <CModalFooter>
                    <CButton color="danger" onClick={() => isViewModalOpen_Doc(!isOpen_Doc)}><i className="fa fa-times" aria-hidden="true"></i>   </CButton>{' '}

                </CModalFooter>
            </CModal>

        </div>

    )
}
export default ModalDocuments